module.exports = __webpack_public_path__ + "static/media/ga.02fbb253.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ga.svg
// module id = 2093
// module chunks = 0